// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608132034/js/" + chunkId + "." + {"44":"131216af","225":"b2998357","481":"b17e3c83","486":"8bd7278e","770":"efc028df"}[chunkId] + ".0.33041579758741446.chunk.js";
};